import { FormValues } from "../types";
import { bffApi } from "../../../../services/bff/bffApi";
import {BaseService} from "../../../../global/classes";

export default class SlcFailedSettlementsService extends BaseService {
  getFailedSettlements = async (
    page:number,
    pageSize:number,
    filter?:FormValues
  )=> {
    const rangeStartReceiveDate = filter?.rangeStartReceiveDate || null;
    const rangeEndReceiveDate = filter?.rangeEndReceiveDate || null;
    const finalReceiverUserType = filter?.finalReceiverUserType || null;

    try {
      const response = await bffApi.get(`/api/slc/v1/failedsettlement/failed-settlements`,
        {
          params: {
            rangeStartReceiveDate: rangeStartReceiveDate,
            rangeEndReceiveDate: rangeEndReceiveDate,
            finalReceiverUserType: finalReceiverUserType,
            pageNumber: page,
            pageSize: pageSize,
            format: "json"
          },
        });

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  getFailedSettlementsXlsxDownload = async (
    filter?: FormValues
  ) => {
    const rangeStartReceiveDate = filter?.rangeStartReceiveDate || null;
    const rangeEndReceiveDate = filter?.rangeEndReceiveDate || null;
    const finalReceiverUserType = filter?.finalReceiverUserType || null;

    try {
      const response = await bffApi.get(`/api/slc/v1/failedsettlement/failed-settlements`,
        {
          params: {
            format: "xlsx",
            rangeStartReceiveDate: rangeStartReceiveDate,
            rangeEndReceiveDate: rangeEndReceiveDate,
            finalReceiverUserType: finalReceiverUserType
          },
          responseType: "blob"
        });

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
